import Button from '../../Atoms/Button/Button'
import './CampaingAssociateClients.scss'
import { Table } from 'antd'

const columns = [
  {
    title: "Cliente",
    dataIndex: "client",
    key: "client",
  },
  {
    title: "Sector",
    dataIndex: "sector",
    key: "sector",
  },
  {
    title: "Tipo de servicio",
    dataIndex: "service",
    key: "service",
  },
  {
    title: "Acciones",
    dataIndex: "actions",
    key: "actions",
    fixed: 'right',
  },
];

const CampaingAssociateClients = () => {

  const clientsList = [
    {
      key: 1,
      client: 'Nombre de cliente en base de datos',
      sector: 'Telecom',
      service: 'Llamadas Inboun',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
    {
      key: 2,
      client: 'Nombre de cliente en base de datos',
      sector: 'Telecom',
      service: 'Llamadas Inboun',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
    {
      key: 3,
      client: 'Nombre de cliente en base de datos',
      sector: 'Telecom',
      service: 'Llamadas Inboun',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
  ]

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
  };
  
  return (
    <div className="box mt-30 s-pxy-20 m-pxy-50">
      <div className="associate-clients_header">
        <p className="source-24">Selecciona uno a más clientes</p>
        <Button content="Asignar/Crear" type="primary" customClass="s-large m-auto" />
      </div>

      <div className="table-container mt-30">
        <Table 
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }} 
        columns={columns} dataSource={clientsList} pagination={false} />
      </div>

      <div className="associate-profile-header_buttons">
        <div className="header-buttons_one">
          <Button content="Gestionar campañas" type="primary outline" customClass="s-large m-auto" />
          <Button content="Guardar proceso" type="primary" customClass="s-large m-auto" />
        </div>
        <div className="header-buttons_two">
          <Button content="Guardar y lanzar campaña" type="primary"  customClass="s-large m-auto"/>
        </div>
      </div>

    </div>
  )
}

export default CampaingAssociateClients
